module.exports = __webpack_public_path__ + "img/29.032ef55c.jpg";